import { isArray } from 'lodash';
import {
  GET_FROM_SUGGESTS,
  GET_FROM_SUGGESTS_SUCCESS,
  SEARCH_SUGGESTS,
  SEARCH_SUGGESTS_SUCCESS,
  CLEAR_SEARCH_SUGGESTS,
} from '../actions/suggest';

const initialState = {
  suggests: [],
  fromSuggests: [],
  defaultFromSuggest: null,

  isSearching: false,
  isLoadingFromSuggests: false,

  fromSuggestsError: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_SUGGESTS: {
      return {
        ...state,
        suggests: [],
        isSearching: true,
      };
    }
    case CLEAR_SEARCH_SUGGESTS: {
      return {
        ...state,
        suggests: [],
        isSearching: false,
      };
    }
    case SEARCH_SUGGESTS_SUCCESS: {
      const { persons } = action.payload;

      return {
        ...state,
        isSearching: false,
        suggests: persons.map(suggest => ({
          ...suggest,
          label: suggest.email,
          value: suggest.email,
        })),
      };
    }
    case GET_FROM_SUGGESTS: {
      return {
        ...state,
        isLoadingFromSuggests: true,
      };
    }
    case GET_FROM_SUGGESTS_SUCCESS: {
      const { mailBoxes, defaultMailBox } = action.payload;

      const fullNameRegexp = /[^<>]+/g;
      let fromSuggests = mailBoxes;
      let defaultFromSuggest = null;

      if (isArray(mailBoxes)) {
        fromSuggests = mailBoxes.map(mailBox => {
          const fullName =
            mailBox.label && (mailBox.label.match(fullNameRegexp) || [])[1];

          return {
            ...mailBox,
            fullName,
          };
        });
      }

      if (defaultMailBox && typeof defaultMailBox === 'object') {
        const fullName =
          defaultMailBox.label &&
          (defaultMailBox.label.match(fullNameRegexp) || [])[1];

        defaultFromSuggest = {
          label: defaultMailBox.value,
          value: defaultMailBox.value,
          fullName,
        };
      }

      return {
        ...state,
        fromSuggests,
        defaultFromSuggest,
        isLoadingEmailFromSuggesting: false,
      };
    }
    default:
      return state;
  }
};
